import { createReducer } from 'reduxsauce';
import { isEqual, cloneDeep, filter } from 'lodash';
import moment from 'moment';

import { CompanyTypes } from '../actions/company.actions';

const initialState = {
  name: '',
  email: '',
  syncRdnFrom: moment().toISOString(),
  emailReplyAddress: 'no-reply@insightt.io',
  stepCounter: 0,
  password: '',
  confirmPassword: '',
  rdnId: '',
  rdnKey: '',
  drnKey: '',
  branches: [],
  branchGroups: [],
  deleted: [],
  users: [],
  deletedUsers: [],
  coreBranches: [],
  roles: [],
  errors: [],
  serverTimezoneOffset: '',
  serverTimezoneLabel: '',
  isEdit: false,
  isDragInProgress: false,
  isAlphaTester: false,
  status: [],
};

const getCompanyDataRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-get-company-data');

  return {
    ...state,
    status,
  };
};
const getCompanyDataSuccess = (state, action) => {
  const { response } = action;
  const { companyDetails } = response;
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-company-data', a));

  return {
    ...state,
    name: companyDetails?.name,
    email: companyDetails?.email,
    syncRdnFrom: moment().toISOString(),
    emailReplyAddress: 'no-reply@insightt.io',
    rdnId: companyDetails?.rdnId,
    rdnKey: companyDetails?.rdnKey,
    drnKey: companyDetails?.drnKey,
    serverTimezoneOffset: companyDetails?.serverTime?.timezone,
    serverTimezoneLabel: companyDetails?.serverTime?.label,
    isAlphaTester: companyDetails?.isAlphaTester === 1,
    status,
  };
};
const getCompanyDataFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-company-data', a));

  return { ...state, status };
};

export const reducer = createReducer(initialState, {
  [CompanyTypes.GET_COMPANY_DATA_REQUEST]: getCompanyDataRequest,
  [CompanyTypes.GET_COMPANY_DATA_SUCCESS]: getCompanyDataSuccess,
  [CompanyTypes.GET_COMPANY_DATA_FAILURE]: getCompanyDataFailure,
});
